import { RolesListRowComponent } from './RolesListRow.types';
import { Flexbox, Icon, Tooltip, Typography } from '@hiiretail/synergy-ui';
import { PermissionBox, TypographyWithEllipsis } from './RolesListRow.styles';

export const RolesListRow: RolesListRowComponent = ({ original, permissions }) => (
  <Flexbox
    container
    alignItems="center"
    gutter={2}
    style={{ width: '100%', overflowY: 'auto', paddingBottom: '16px' }}
  >
    <>
      {original.fixedBindings?.length ? <>
        <Tooltip title={<>
          <Typography color={()=>"white"}>
            Fixed bindings: <br/><br/>
            {original.fixedBindings.map(fixedBinding => (<div key={fixedBinding}>
              {fixedBinding}
            </div>))}
          </Typography>
        </>}>
          <div data-testid="tooltip">
            <Icon.Info size="md" />
          </div>
        </Tooltip>
      </> : null}
      {original.permissions.map((id) => (
        <PermissionBox item key={`${original.id}-${original.name}-${id}`}>
          {/*  @ts-ignore  */}
          <TypographyWithEllipsis variant="caption" weight="bold">
            {permissions?.find((permission) => permission.id === id)?.id}
          </TypographyWithEllipsis>
        </PermissionBox>
      ))}
    </>
  </Flexbox>
);
